import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const formatCurrency = (amount, locale = 'es-MX', currency = 'USD') => {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 2,
  }).format(amount);
};

export const formatDate = (date, locale = 'es-MX') => {
  if (!date) return '';
  const d = typeof date === 'string' ? new Date(date) : date;
  return new Intl.DateTimeFormat(locale, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  }).format(d);
};

export const formatDateTime = (date, locale = 'es-MX') => {
  if (!date) return '';
  const d = typeof date === 'string' ? new Date(date) : date;
  return new Intl.DateTimeFormat(locale, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(d);
};

export const TAX_RATE = 0.07;
export const TAX_NAME = 'ITBMS';

export const calculateTax = (subtotal) => {
  return Math.round(subtotal * TAX_RATE * 100) / 100;
};

export const calculateTotal = (subtotal) => {
  const tax = calculateTax(subtotal);
  return Math.round((subtotal + tax) * 100) / 100;
};

export const getStockStatus = (stock, minStock) => {
  if (stock === 0) return { status: 'out', label: 'Agotado', color: 'destructive' };
  if (stock <= minStock) return { status: 'low', label: 'Stock bajo', color: 'warning' };
  return { status: 'ok', label: 'Disponible', color: 'success' };
};

export const getOrderStatusLabel = (status) => {
  const labels = {
    pending: 'Pendiente',
    confirmed: 'Confirmado',
    ready: 'Listo',
    delivered: 'Entregado',
    cancelled: 'Cancelado',
  };
  return labels[status] || status;
};

export const getInvoiceStatusLabel = (status) => {
  const labels = {
    pending: 'Pendiente',
    paid: 'Pagada',
    cancelled: 'Cancelada',
  };
  return labels[status] || status;
};

export const getQuotationStatusLabel = (status) => {
  const labels = {
    draft: 'Borrador',
    sent: 'Enviada',
    accepted: 'Aceptada',
    rejected: 'Rechazada',
    converted: 'Convertida',
  };
  return labels[status] || status;
};

export const debounce = (func, wait) => {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
};
